var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.showAnnexure == false) ? _c('b-card', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Add New Annexure"
    },
    on: {
      "click": _vm.showCreateAnnexure
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-lg"
  })])])])])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Annexure List")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Total Records: " + _vm._s(_vm.totalCount))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumn,
      "isEditHidden": true,
      "offset": _vm.offset,
      "isViewHidden": true,
      "isDelete": true,
      "items": _vm.tableItems
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage > 1) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showAnnexure == true) ? _c('div', [_c('div', [_c('create-annexure', {
    attrs: {
      "contractId": _vm.contractId,
      "callingFromClientContract": _vm.callingFromClientContract
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1)]) : _vm._e()], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f03b0a0","hasScoped":true}!./src/modules/shared/components/Template1/annexures/annexures.component.html
// module id = 620
// module chunks = 3